import VesselHeader from "./VesselHeader";

const OverviewFilter = () => {
  return (
    <div className="relative flex items-center justify-between w-full">
      <VesselHeader pageTitle="Vessel Overview" />
    </div>
  );
};

export default OverviewFilter;